// src/utils/cloudinaryUtils.js
import axios from 'axios';

export const uploadVideoToCloudinary = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', 'yo9knexr');
  formData.append('resource_type', 'video');
  formData.append('audio_codec', 'none');
  
  try {
    const response = await axios.post('https://api.cloudinary.com/v1_1/dbnpd7exf/video/upload/', formData);
    return {
      secureUrl: response.data.secure_url,
      publicId: response.data.public_id
    };
  } catch (error) {
    console.error('Error al subir el video a Cloudinary:', error);
    throw new Error('No se pudo cargar el video a Cloudinary');
  }
};